/**
 * Build identity reported to the API as `X-App-Version`.
 *
 * Vite replaces `__APP_VERSION__` at build time (and in dev) with the git
 * short hash from `vite-plugins/pwa-cache-bust.ts` — the same string the PWA
 * assets are cache-busted with, so a reported version names an exact deploy.
 * Outside a Vite build (jest) the symbol is absent; `typeof` on an undeclared
 * identifier is safe, so the fallback keeps module import from throwing.
 */
export const APP_VERSION =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
